<!--
 * @Author: your name
 * @Date: 2021-09-17 11:43:35
 * @LastEditTime: 2021-09-27 16:33:07
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \myredhat-website\src\views\consult.vue
-->

<template>
  <div class="consult">
    <div class="banner">
      <img src="@/assets/consult/consultInd.png">
    </div>
    <div class="consult inner">
      <div class="consulTop">
        <p><span>Industry information</span><br><span>行业咨询</span></p>
      </div>
      <div class="consulBottom">
        <div v-for="item in consulBottomList" :key="item.id">
          <img :src="item.url" alt="">
          <div class="consulBottomTxt">
            <div class="fl"><span>01</span><br><span>五月</span></div>
            <div class="fl">
              <p>{{item.tit}}</p>
              <p>{{item.content}}</p>
              <p @click="click(item.id)">{{item.more}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footerPage></footerPage>
  </div>
</template>

<script>
import '@/css/consult.css'
import '@/css/public.css'
import footerPage from '../components/Footer'
export default {
  components: {
    footerPage,
  },
  data() {
    return {
      consulBottomList: [
        {
          id: 1, url: require("@/assets/consult/1.png"), tit: '系统不能用？临时升级凌晨3点完成， 现正常运行', content: '受“国庆期间护网行动“的政策影响，人证 实名认证，OCR证照识别，人实名认证，O CR证照识别实名认证，OCR识别...',
          more: '查看更多>>'
        },
        {
          id: 2, url: require("@/assets/consult/2.png"), tit: '系统不能用？临时升级凌晨3点完成， 现正常运行', content: '受“国庆期间护网行动“的政策影响，人证 实名认证，OCR证照识别，人实名认证，O CR证照识别实名认证，OCR识别...',
          more: '查看更多>>'
        },
        {
          id: 3, url: require("@/assets/consult/3.png"), tit: '系统不能用？临时升级凌晨3点完成， 现正常运行', content: '受“国庆期间护网行动“的政策影响，人证 实名认证，OCR证照识别，人实名认证，O CR证照识别实名认证，OCR识别...',
          more: '查看更多>>'
        }
      ],
    }
  },
  methods: {
    click(id) {
      this.$router.push('/ConsultDetails/' + id);
    }
  }
}
</script>

<style>
</style>